import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as ReactDOM from 'react-dom'
import Root from './App'
import '@/assets/styles/index.less'
import { ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import zhCN from 'antd/locale/zh_CN'
// import { initSentry } from '@/utils/sentryUser'
dayjs.locale('zh-cn')
// initSentry()
ReactDOM.render(
  <ConfigProvider
    locale={zhCN}
    theme={{
      token: {
        // Seed Token，影响范围大
        colorPrimary: '#29B248'
        // 派生变量，影响范围小
        // colorBgContainer: '#f6ffed'
      }
    }}
  >
    <Root />
  </ConfigProvider>,
  document.getElementById('root') as HTMLElement
)
